import React, { useState } from "react"
import { translate } from "react-i18next"
import compose from "ramda/src/compose"
import PropTypes from "prop-types"

import {
  RECHARGE_DOCUMENTS_BUTTON_DOWNLOAD,
  RECHARGE_DOCUMENTS_BUTTON_DOWNLOAD_SELECTED
} from "shared/constants/idsElements"
import ModernButton from "shared/components/Button/ModernButton"
import InputCheckbox from "../../../InputCheckbox"
import DownloadButton from "../../../../assets/svg/downloads.svg"

import styles from "../../styles.css"

import { numberToReal } from "services/utils/mask"

const getDocumentTypeText = (type) => {
  if (type === "NOTAFISCAL" || type === "NFCOM") {
    return "Nota fiscal"
  }
  if (type === "FATURA") {
    return "Fatura"
  }
  return type
}

const PrePaidDocumentsTable = ({
  t,
  tableData,
  onDownload,
  onDownloadMultiple,
  downloadingMultiple,
  documentType
}) => {
  const [selectedDocs, setSelectedDocs] = useState([])

  const handleSelect = (item) => {
    setSelectedDocs((prev) =>
      prev.some((doc) => doc.invoiceNumber === item.invoiceNumber)
        ? prev.filter((doc) => doc.invoiceNumber !== item.invoiceNumber)
        : [...prev, item]
    )
  }

  const handleSelectAll = () => {
    if (selectedDocs.length === tableData.length) {
      setSelectedDocs([])
    } else {
      setSelectedDocs(tableData)
    }
  }

  const handleDownloadMultiple = () => {
    if (selectedDocs.length > 0 && onDownloadMultiple) {
      const documentsToDownload = selectedDocs.map((doc) => ({
        invoiceNumber: doc.invoiceNumber,
        type: doc.documentType
      }))

      onDownloadMultiple(documentsToDownload)
    }
  }

  return (
    <div>
      <table className={`${styles.table} u-posRelative`}>
        <thead className={styles.tableHeader}>
          <tr>
            <th>{documentType === "FATURA" ? "Fatura" : "NF"}</th>
            <th>{t("VALUE")}</th>
            <th>{t("MSG_0060")}</th>
            <th>{t("MSG_0494")}</th>
            <th></th>
          </tr>
        </thead>

        <tbody className={styles.tableBody}>
          {tableData.length === 0 ? (
            <tr>
              <td style={{ whiteSpace: "nowrap" }}>{t("MSG_0186")}</td>
            </tr>
          ) : (
            tableData.map((item) => (
              <tr key={item.invoiceNumber}>
                <td>
                  <InputCheckbox
                    value={item.invoiceNumber}
                    label={item.invoiceNumber}
                    customLabel={styles.customLabel}
                    onChange={() => handleSelect(item)}
                    checked={selectedDocs.some(
                      (doc) => doc.invoiceNumber === item.invoiceNumber
                    )}
                  />
                </td>
                <td>{`R$ ${numberToReal(item.amount)}`}</td>
                <td>{item.monthYear}</td>
                <td>{getDocumentTypeText(item.documentType)}</td>
                <td>
                  <button
                    id={RECHARGE_DOCUMENTS_BUTTON_DOWNLOAD}
                    className={styles.downloadButton}
                    onClick={() => onDownload && onDownload(item)}
                  >
                    <img src={DownloadButton} alt="Baixar documento" />
                  </button>
                </td>
              </tr>
            ))
          )}
        </tbody>

        {tableData.length > 0 && (
          <tfoot className={styles.tableFooter}>
            <tr>
              <td>
                <InputCheckbox
                  label={t("MSG_0495")}
                  customLabel={styles.customLabel}
                  onChange={handleSelectAll}
                  checked={
                    tableData.length > 0 &&
                    selectedDocs.length === tableData.length
                  }
                />
              </td>
              <td colSpan="4" style={{ textAlign: "right" }}>
                <ModernButton
                  id={RECHARGE_DOCUMENTS_BUTTON_DOWNLOAD_SELECTED}
                  shape="full"
                  size="medium"
                  buttonColor="deep_sea_green"
                  text={t("DOWNLOAD_ALL_SELECTED")}
                  textColor="white"
                  textSize="small"
                  withBorderRadius
                  onClick={handleDownloadMultiple}
                  isDisabled={selectedDocs.length === 0 || downloadingMultiple}
                />
              </td>
            </tr>
          </tfoot>
        )}
      </table>
    </div>
  )
}

PrePaidDocumentsTable.propTypes = {
  t: PropTypes.func,
  tableData: PropTypes.array.isRequired,
  onDownload: PropTypes.func,
  onDownloadMultiple: PropTypes.func,
  downloadingMultiple: PropTypes.bool,
  documentType: PropTypes.string
}

const enhance = compose(translate())

export default enhance(PrePaidDocumentsTable)



// WEBPACK FOOTER //
// ./src/components/RechargeDocuments/components/PrePaidDocuments/PrePaidDocumentsTable.js